<template>
  <router-view name="serviceRegion" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "ServiceRegion",
};
</script>